export const business = {
  name: "Anzivino's Sweets & Boutique",
  shortName: "Anzivino's",
  categories: ["Ice Cream", "Apparel", "Coffee"],
  bio: "Home of the first ice cream taco",
  address: "8 Washington St, Ellicottville, NY 14731",
  addressFull: "8 Washington St, Ellicottville, NY 14731, USA",
  phone: "(716) 699-9079",
  phoneHref: "tel:17166999079",
  email: "shopanzivinos@gmail.com",
  emailHref: "mailto:shopanzivinos@gmail.com",
  social: {
    instagram: "https://www.instagram.com/anzivinos/",
    facebook: "https://www.facebook.com/449191021608683",
    tiktok: "https://www.tiktok.com/@anzivinos"
  },
  maps: {
    link: "https://www.google.com/maps/search/?api=1&query=8%20Washington%20St%2C%20Ellicottville%2C%20NY%2014731",
    embed: "https://www.google.com/maps?q=8%20Washington%20St%2C%20Ellicottville%2C%20NY%2014731&output=embed",
    latitude: 42.2773894,
    longitude: -78.6689264
  },
  hours: [
    ["Mon", "11:00 am - 06:00 pm"],
    ["Tue", "11:00 am - 06:00 pm"],
    ["Wed", "11:00 am - 06:00 pm"],
    ["Thu", "11:00 am - 08:00 pm"],
    ["Fri", "11:00 am - 09:00 pm"],
    ["Sat", "11:00 am - 09:00 pm"],
    ["Sun", "11:00 am - 06:00 pm"]
  ]
};

export const storefront = {
  salesChannel: "staging",
  locale: "en-US",
  currency: "USD",
  priceIncludesTax: false,
  taxPolicy: "Taxes and shipping are confirmed during direct checkout request.",
  checkoutMode: "email_request",
  orderEmail: business.email,
  cartStorageKey: "anzivinos-cart:v2",
  freeShippingThresholdCents: null,
  announcement: "Get 10% off when you join our email list!",
  newsletterOffer: "10% off your first purchase"
};

export const instagramProfile = {
  handle: "@anzivinos",
  posts: "435",
  followers: "4,001",
  following: "689",
  profile: "Anzivino's Sweets & Boutique",
  bio: ["Home of the first ice cream taco", "Ice Cream • Apparel • Coffee"],
  location: "Ellicottville, NY"
};

export const products = [
  {
    id: "coffee",
    sku: "ANZ-COFFEE-GROUNDS-12OZ",
    slug: "specialty-coffee-blend--grounds",
    path: "/shop/ols/products/specialty-coffee-blend--grounds/",
    name: "Specialty Coffee Blend- GROUNDS",
    status: "active",
    productType: "coffee",
    taxable: true,
    inventoryPolicy: "contact_for_availability",
    priceCents: 2000,
    currency: storefront.currency,
    image: "/assets/images/coffee-blend-clean.jpg",
    sourceImage: "/assets/images/coffee-blend.jpg",
    description: "Our own unique specialty blend. Origins from Latin America. Tastes like hazelnut, cocoa, and cherry. 12oz.",
    tags: ["Latin America origins", "Hazelnut", "Cocoa", "Cherry", "12oz"],
    variants: [
      {
        id: "coffee-grounds-12oz",
        label: "12oz grounds",
        priceCents: 2000,
        sku: "ANZ-COFFEE-GROUNDS-12OZ"
      }
    ]
  }
];

export const gallery = [
  { image: "/assets/images/ice-cream-tacos.jpg", title: "Signature ice cream tacos", position: "center 40%" },
  { image: "/assets/images/grand-opening-storefront.jpg", title: "Pink storefront on Washington Street", position: "center" },
  { image: "/assets/images/about-sign-upright.jpg", title: "Storefront sign and pink windows", position: "center" },
  { image: "/assets/images/about-cone.jpg", title: "Cone dipped in color", position: "center" },
  { image: "/assets/images/peppermint-hot-chocolate.jpg", title: "Specialty hot chocolate", position: "center" },
  { image: "/assets/images/pink-houndstooth-scarves.jpg", title: "Boutique accessories", position: "center" },
  { image: "/assets/images/boutique-coats.jpg", title: "Apparel and cozy layers", position: "center" },
  { image: "/assets/images/storefront-sign.jpg", title: "Anzivino's sign", position: "center" },
  { image: "/assets/images/newsletter-cart.jpg", title: "Cart bookings and events", position: "center" }
];

export const instagramFeed = [
  { image: "/assets/images/gallery-5951-upright.jpg", title: "Ice cream tacos in the shop", position: "center 34%" },
  { image: "/assets/images/about-cone.jpg", title: "Cone dipped in color", position: "center" },
  { image: "/assets/images/grand-opening-storefront.jpg", title: "Pink storefront on Washington Street", position: "center" },
  { image: "/assets/images/peppermint-hot-chocolate.jpg", title: "Specialty hot chocolate", position: "center" },
  { image: "/assets/images/pink-houndstooth-scarves.jpg", title: "Boutique accessories", position: "center" },
  { image: "/assets/images/boutique-coats.jpg", title: "Apparel and cozy layers", position: "center" },
  { image: "/assets/images/coffee-blend.jpg", title: "Specialty coffee blend", position: "center 30%" },
  { image: "/assets/images/about-sign-upright.jpg", title: "Storefront sign and pink windows", position: "center" },
  { image: "/assets/images/newsletter-cart.jpg", title: "Cart bookings and events", position: "center" }
];

export const policies = {
  returnPolicy: [
    "Terms of return: 30 days after purchase.",
    "State of return: unworn or unused return items only.",
    `Process for return: contact ${business.email} with information and reason for return.`
  ],
  privacy: [
    "A full privacy policy can be added here when the business is ready.",
    `For privacy questions, contact ${business.email}.`
  ],
  terms: [
    "Terms and conditions can be added here before production launch.",
    `For order questions, contact ${business.email} or call ${business.phone}.`
  ]
};

export const routes = {
  "/": { title: "Anzivino's Sweets & Boutique", page: "home" },
  "/shop/": { title: "Shop | Anzivino's", page: "shop" },
  "/shop/ols/products/specialty-coffee-blend--grounds/": {
    title: "Specialty Coffee Blend- GROUNDS | Anzivino's",
    page: "product"
  },
  "/about/": { title: "About | Anzivino's", page: "about" },
  "/policy/": { title: "Policy | Anzivino's", page: "policy" },
  "/privacy-policy/": { title: "Privacy Policy | Anzivino's", page: "privacy" },
  "/terms-and-conditions/": { title: "Terms and Conditions | Anzivino's", page: "terms" },
  "/sign-up/": { title: "Sign Up | Anzivino's", page: "signup" },
  "/m/account/": { title: "Account | Anzivino's", page: "account" },
  "/m/create-account/": { title: "Create Account | Anzivino's", page: "createAccount" },
  "/m/orders/": { title: "Orders | Anzivino's", page: "orders" },
  "/m/login/": { title: "Sign In | Anzivino's", page: "login" }
};
